module.exports = __webpack_public_path__ + "img/answer_bg.b14b959e.jpg";